import styled from "styled-components";
import colors from "../../../config/colors";
import { isMobile } from "../../../utils/common";

export const HomeContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color:${colors.background};
`;

export const HomeContent = styled.div`
  background-color: ${colors.primary}30;
  border-radius: 40px 40px;
  ${isMobile()
    ? `
        width:95vw;
        margin-top:100px;
        `
    : `
        max-width:90vw;
        min-width:90vw;
        `}
`;

export const LastHomeContent = styled(HomeContent)`
  ${isMobile() ? "margin-top:0px" : ""};
  border-radius:40px 40px 0px 0px;
`;
